import { height } from "@mui/system";
import React, { useContext, useState } from "react";
import AuthContext from "../context/userAuth.context";
import "../css/login.scss";
import Checkbox from "@mui/material/Checkbox";
import { useHistory } from "react-router";
import FormControlLabel from "@mui/material/FormControlLabel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
export const ResetPassword = (props) => {
  let history = useHistory();
  const { authenticationData } = useContext(AuthContext);
  const codetoken = useFormInput("");
  const password = useFormInput("");
  const cpassword = useFormInput("");

  const [LoginError, setLoginError] = useState({
    status: false,
    text: "",
  });
  const [EmailSent, setEmailSent] = useState({
    status: false,
    text: "",
  });

  const [LoginInProcess, setLoginInProcess] = useState(false);

  const resetpassword = (e) => {
    setLoginError({
      status: false,
      text: "",
    });
    e.preventDefault();
    if (
      password.value != "" &&
      cpassword.value != "" &&
      codetoken.value != ""
    ) {
      if (password.value == cpassword.value) {
        var url = window.location.href;
        var hashes = url.split("=")[1];
        var email = hashes;
        let formdata = new FormData();
        formdata.append("email", email);
        formdata.append("password", password.value);
        formdata.append("token", codetoken.value);
        axios
          .post(
            authenticationData.ApiBaseURL + "/api/Account/ResetPassword",
            formdata,
            {
              headers: {
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((res) => {
            console.log(res.data.result);
            if (res.data.result === "Password Reset Successfull.") {
              setEmailSent({
                status: true,
                text:
                  "" +
                  res.data.result +
                  " Go to login page and sign in with your new password.",
              });
            } else {
              setLoginError({
                status: true,
                text: "" + res.data.result,
              });
            }
          });
      } else {
        setLoginError({
          status: true,
          text: "Password and confirm passwords don't match.",
        });
      }
    } else {
      setLoginError({
        status: true,
        text: "Please fill all fields.",
      });
    }
  };

  return (
    <>
      <div className="limiter">
        <div className="container-login100">
          <div className="wrap-login100">
            <div
              className="login100-more"
              style={{ backgroundImage: "url('images/reset_2.svg')" }}
            >
              <div className="p-5">
                {/* <h1 className="headlineCustom">
                  <span className="primaryColor">Create ,</span> Innovate...
                  Animate.
                </h1> */}
              </div>
            </div>

            <form className="login100-form validate-form">
              <span className="login100-form-title mb-4">
                <img className="logoLogin mb-3" alt="" src="images/Logo.png" />
              </span>
              <span className="login100-form-title mb-5 primaryColor">
                Enter new password
              </span>

              <div
                className="wrap-input100 validate-input"
                data-validate="Valid email is required: ex@abc.xyz"
              >
                <input
                  className="input100 has-val"
                  type="text"
                  name="email"
                  {...codetoken}
                />
                <span className="focus-input100"></span>
                <span className="label-input100">
                  Code token (Sent in email)
                </span>
              </div>

              <div
                className="wrap-input100 validate-input"
                data-validate="Password is required"
              >
                {/* <span className="showPass">
                  <VisibilityIcon />
                </span> */}
                <input
                  className="input100 has-val"
                  type="password"
                  name="pass"
                  {...password}
                />

                <span className="focus-input100"></span>
                <span className="label-input100">New password</span>
              </div>
              <div
                className="wrap-input100 validate-input"
                data-validate="Password is required"
              >
                <input
                  className="input100 has-val"
                  type="password"
                  name="cpass"
                  {...cpassword}
                />
                <span className="focus-input100"></span>
                <span className="label-input100">Confirm password</span>
              </div>

              <div className="flex-sb-m mb-4">
                {/* <div className="contact100-form-checkbox">
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        // onClick={(e) => setrememberMe(e.target.checked)}
                        checked={true}
                      />
                    }
                    label="Remember me"
                  />
                </div> */}
              </div>

              <div className="container-login100-form-btn mb-2">
                <button
                  className="login100-form-btn"
                  onClick={(e) => resetpassword(e)}
                >
                  {LoginInProcess && (
                    <span>
                      Validating
                      <div
                        className="spinner-border text-light"
                        role="status"
                        style={{
                          width: "15px",
                          height: "15px",
                          marginLeft: "5px",
                        }}
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </span>
                  )}
                  {!LoginInProcess && <span>Reset password</span>}
                </button>
              </div>
              {EmailSent.status && (
                <div className="success-noti mb-5">
                  <label className="text-white">{EmailSent.text}</label>
                </div>
              )}
              {LoginError.status && (
                <div className="error-noti mb-5">
                  <label className="text-white">{LoginError.text}</label>
                </div>
              )}

              <div className="text-center mb-4">
                <br></br>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push("./");
                  }}
                >
                  <span className="txt1">Go back to login</span>
                </div>
                <br></br>
                <br></br>
                <span>
                  <a
                    style={{ color: "blue" }}
                    href="https://app.toons.ai/support/"
                    target="_blank"
                  >
                    Contact Support
                  </a>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);
  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};

export default ResetPassword;
